import { render, staticRenderFns } from "./QuickLinksTags.vue?vue&type=template&id=a2af27e4&"
import script from "./QuickLinksTags.vue?vue&type=script&lang=js&"
export * from "./QuickLinksTags.vue?vue&type=script&lang=js&"
import style0 from "./QuickLinksTags.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports